import React from "react";
import ModuleList from "../v2/CustomisationWorkspace/WorkspaceComponents/ModuleList/ModuleList";
import { getGroupData } from "../v2/CustomisationWorkspace/WorkspaceComponents/EditablePreview/EditablePreview";
import GeneralErrorBoundary from "../../containers/AppErrorBoundary/GeneralErrorBoundary";

const RightSidebar = (props) => {
  const onResetView = props.onResetView;

  const getSettingsPath = (node, pathArray = []) => {
    pathArray.unshift(node);
    if (node.parent && node.parent.depth > 0) {
      return getSettingsPath(node.parent, pathArray);
    }
    return pathArray;
  }

  const getSelectedAudioLabel = () => {
    const selectedFileIndex = props.activeTimelineAudioGroup?.selectedFileIndex;
    const audioFileDataLink = props.activeTimelineAudioGroup?.audioData?.['audio-file'];
    if (typeof selectedFileIndex !== 'number' || !audioFileDataLink) return null;

    const audioGroupPath = audioFileDataLink.split('.').slice(0, -1).join('.');
    const audioItems = getGroupData(props.customisationVars || {}, audioGroupPath, -1);
    const selectedItem = Array.isArray(audioItems) ? audioItems[selectedFileIndex] : null;
    const strOrNull = (v) => (typeof v === 'string' && v ? v : null);
    return strOrNull(selectedItem?.name) || strOrNull(selectedItem?.audioFilename) || strOrNull(selectedItem?.filename) || `Audio ${selectedFileIndex + 1}`;
  };

  const selectedAudioLabel = getSelectedAudioLabel();

  return (
    <div className="timeline-editor-col controls">
      <h3>
        {props.selectedFeatureNode ? `${props.selectedFeatureNode.name} Settings` : 'Nothing Selected'}
        {props.activeNode &&
          <span className="right-sidebar-settings-path">
            <br />
            {getSettingsPath(props.activeNode).map((pathNode, index, arr) => (
              <span key={index}>
                <span className={`${index < arr.length - 1 ? "node-link" : "active-node"}`} onClick={index < arr.length - 1 ? () => props.activateNodeFunction(pathNode) : undefined}>{pathNode.name}</span>
                {index < arr.length - 1 && ' > '}
              </span>
            ))}
          </span>
        }
        {props.activeTimelineAudioGroup && (
          <span className="right-sidebar-settings-path">
            <br />
            Audio [{props.activeTimelineAudioGroup.groupData.name}]{' > '}
            <span className="active-node">{props.activeTimelineAudioGroup.audioData.name}</span>
            {selectedAudioLabel && <><span>{' > '}</span><span className="active-node">{selectedAudioLabel}</span></>}
          </span>
        )}
        {props.activeTimelineDisruptorGroup && <span className="right-sidebar-settings-path"><br />Disruptors [{props.activeTimelineDisruptorGroup.groupData.name}]{' > '}<span className="active-node">{props.activeTimelineDisruptorGroup.disruptorData.name}</span></span>}
      </h3>
      {/* <div className="controls-placeholder">
        Content to be added
      </div> */}

      <GeneralErrorBoundary message="Settings unavailable">
        <ModuleList
          {...props}
        />
      </GeneralErrorBoundary>

      <button
        onClick={onResetView}
        style={{
          padding: '0.5rem 1rem',
          background: 'var(--primary-color, #007bff)',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          width: '100%'
        }}
      >
        Reset View
      </button>
    </div>
  );
};

export default RightSidebar;
